<template>
  <span v-if="hasAnyIds">
    <external-id-tag
      v-if="author.authorid"
      tag-name="Semantic Scholar"
      :tag-value="author.authorid"
      :link="getLink('Semantic Scholar', author.url)"
    />
    <external-id-tag
      v-if="author.externalidsDblp?.length > 0"
      tag-name="DBLP"
      :tag-value="author.externalidsDblp"
      array-key="dblp"
      :link="getLink('DBLP', author.externalidsDblp)"
    />
    <external-id-tag
      v-if="
        author.externalidsOrcid?.length > 0 ||
        author.openalexAuthorship?.author?.orcid
      "
      tag-name="ORCID"
      :tag-value="
        author.externalidsOrcid?.length > 0
          ? author.externalidsOrcid
          : [
              {
                orcid: author.openalexAuthorship.author.orcid.replace(
                  'https://orcid.org/',
                  '',
                ),
              },
            ]
      "
      array-key="orcid"
      :link="
        getLink(
          'ORCID',
          author.externalidsOrcid?.length > 0
            ? author.externalidsOrcid
            : [
                {
                  orcid: author.openalexAuthorship.author.orcid.replace(
                    'https://orcid.org/',
                    '',
                  ),
                },
              ],
        )
      "
    />
    <external-id-tag
      v-if="author.openalexAuthorship?.author?.id"
      tag-name="OpenAlex"
      :tag-value="
        author.openalexAuthorship.author.id.replace('https://openalex.org/', '')
      "
      :link="getLink('OpenAlex', author.openalexAuthorship.author.id)"
    />
  </span>
</template>

<script>
import ExternalIdTag from "./ExternalIdTag.vue";

export default {
  components: {
    ExternalIdTag,
  },
  props: {
    author: Object,
  },
  computed: {
    hasAnyIds() {
      return (
        this.author.authorid ||
        (this.author.externalidsDblp &&
          this.author.externalidsDblp.length > 0) ||
        (this.author.externalidsOrcid &&
          this.author.externalidsOrcid.length > 0) ||
        this.author.openalexAuthorship?.author?.id ||
        this.author.openalexAuthorship?.author?.orcid
      );
    },
  },
  methods: {
    getLink(idType, id) {
      switch (idType) {
        case "Semantic Scholar":
          return `${id}`;
        case "DBLP":
          return id.map((item) => `https://dblp.org/search?q=${item.dblp}`);
        case "ORCID":
          return id.map((item) => `https://orcid.org/${item.orcid}`);
        case "OpenAlex":
          return id;
        default:
          return null;
      }
    },
  },
};
</script>
